import request from "./request"
import {getToken} from "@/assets/js/modules/auth"

//登录 {JobNo: "", Pwd: ""}
export function login(data){
    return request({
        url: "/api/User/LoginAsync",
        method: "post",
        data
    })
} 

//刷新Token {Access_Token: ""}
export async function refreshToken(data){
    return request({
        url: "/api/User/RefreshToken",
        method: "post",
        data
    })
}

//获取信息 {Id}
export function getInfo(data){
    return request({
        url: "/api/User/GetAsync",
        method: "post",
        data
    })
}

//修改用户头像 {Id: "", FileContent: "", FileExtentsion: ""}
export function updateAvatar(data){
    return request({
        url: "/api/User/UpdateAvatarAsync",
        method: "post",
        data
    })
}

//修改用户昵称 {Id: "", NickName: ""}
export function updateNickName(data){
    return request({
        url: "/api/User/UpdateAsync",
        method: "post",
        data
    }) 
}

//修改用户密码 {OldPwd: "",NewPwd: "", Id: ""}
export function updatePassword(data){
    return request({
        url: "/api/User/UpdatePasswordAsync",
        method: "post",
        data
    })
}

//获取用户原创列表{UserId: "",  Sorting: "", SkipCount: "", MaxResultCount: ""}
export function getOriginalList(data){
    return request({
        url: "/api/User/GetUserOriginalListAsync",
        method: "post",
        data
    })
}

//删除用户原创文件 {UserId: "", SourceID: "", SourceType: ""}
export function deleteOriginal(data){
    return request({
        url: "/api/User/DeleteUserOriginalAsync",
        method: "post",
        data
    })
}

//获取消息列表 {UserID: "",NewsCategory: 1, Status: 0, Sorting: "", SkipCount: "", MaxResultCount: ""}
export function getMessageList(data){
    return request({
        url: "/api/User/GetReadListAsync",
        method: "post",
        data
    })
}

//设置消息已读 {Ids: [], UserID: ""}
export function setMessageRead(data){
    return request({
        url: "/api/Words/SetReadListAsync",
        method: "post",
        data
    })
}

//获取动态列表 {UserID: "",NewsCategory: 2, Status: "", Sorting: "", SkipCount: "", MaxResultCount: ""}
export function getDynamicList(data){
    return request({
        url: "/api/User/GetReadListAsync",
        method: "post",
        data
    })
}

//设置动态已读 {Ids: [], UserID: ""}
export function setDynamicRead(data){
    return request({
        url: "/api/FileComprehensive/SetReadListAsync",
        method: "post",
        data
    })
}

//获取收藏列表 {UserID: "", Sorting: "", SkipCount: "", MaxResultCount: ""}
export function getCollectList(data){
    return request({
        url: "/api/FileComprehensive/GetFavoritesListAsync",
        method: "post",
        data
    })
}

//创建或者更改收藏夹名称 {Id: "", Name: "", UserId: "", Sort: ""}
export function addOrUpdateCollect(data){
    return request({
        url: "/api/FileComprehensive/CreateUpdateFavoritesAsync",
        method: "post",
        data
    })
}

//删除收藏夹 {Id: ""}
export function deleteCollect(data){
    return request({
        url: "/api/FileComprehensive/DeleteFavoritesAsync",
        method: "post",
        data
    })
}

//根据收藏夹Id获取封面图片列表 {FavoritesId: "", Sorting: "",SkipCount: "",MaxResultCount: ""}
export function getCoverimgList(data){
    return request({
        url: "/api/FileComprehensive/GetFavoritesDownCoverImgListAsync",
        method: "post",
        data
    })
}

//根据收藏夹Id获取收藏夹详情列表 {UserId: "", FavoritesId: "",Sorting: "",SkipCount: "",MaxResultCount: ""}
export function getCollectDetail(data){
    return request({
        url: "/api/User/GetUserCollectListAsync",
        method: "post",
        data
    })
}

//收藏文章或文件 {SourceID: "", UserID: "", SourceType: "",Type: 2, FavoritesId: ""}
export function collectFile(data){
    return request({
        url: "/api/FileComprehensive/CreateAsync",
        method: "post",
        data
    })
}

//修改收藏夹封面图 {Id: "", FavoritesId: ""}
export function updateCoverimg(data){
    return request({
        url: "/api/FileComprehensive/UpdateFavoritesCoverImgAsync",
        method: "post",
        data
    })
}

//获取用户未读消息数目 {Id: ""}
export function getUnreadCount(data){
    return request({
        url: "/api/User/GetUserReadCountAsync",
        method: "post",
        data
    })
}

//更新文件到指定收藏夹 {FileComprehensiveId: "", NewFavoritesId: ""}
export function updateCollectFile(data){
    return request({
        url: "/api/FileComprehensive/UpdateFavoritesIdAsync",
        method: "post",
        data
    })
}

//取消收藏文件 {UserId: "", FileComprehensiveId: ""}
export function cancelCollect(data){
    return request({
        url: "/api/FileComprehensive/DeleteAsync",
        method: "post",
        data
    })
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/userApi.js